export const GET_ARTIST = "GET_ARTIST";
export const CREATE_ARTIST = "CREATE_ARTIST";
export const EDIT_ARTIST = "EDIT_ARTIST";
export const DELETE_ARTIST = "DELETE_ARTIST";
export const TOGGLE_ARTIST_ACTIVE = "TOGGLE_ARTIST_ACTIVE";
